import { Box, alpha, useTheme } from '@mui/material';

interface LoadingSpinnerProps {
  size?: number;
  fullPage?: boolean;
}

export function LoadingSpinner({ size = 40, fullPage = false }: LoadingSpinnerProps) {
  const theme = useTheme();

  return (
    <Box
      sx={fullPage ? {
        position: 'fixed',
        inset: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: alpha(theme.palette.background.default, 0.85),
        backdropFilter: 'blur(12px)',
        WebkitBackdropFilter: 'blur(12px)',
        zIndex: 9999,
        animation: 'fadeIn 0.4s ease-out tracking-in-expand',
        '@keyframes fadeIn': { from: { opacity: 0 }, to: { opacity: 1 } },
      } : {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        py: 6,
        width: '100%'
      }}
    >
      <Box sx={{
        position: 'relative',
        width: fullPage ? 140 : Math.max(size, 80),
        height: fullPage ? 140 : Math.max(size, 80),
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        bgcolor: 'transparent',
        transformOrigin: 'center',
        animation: 'floatPulse 3s infinite ease-in-out',
        '@keyframes floatPulse': {
          '0%': { transform: 'scale(1) translateY(0px)' },
          '50%': { transform: 'scale(1.02) translateY(-4px)' },
          '100%': { transform: 'scale(1) translateY(0px)' }
        }
      }}>
        <img
           src="/loading.gif"
           alt="Loading..."
           style={{
             width: '100%',
             height: '100%',
             objectFit: 'contain',
             pointerEvents: 'none',
             filter: fullPage ? 'drop-shadow(0 4px 12px rgba(0,0,0,0.1))' : 'none'
           }}
        />
      </Box>
    </Box>
  );
}
